import React from 'react'
import { Helmet } from "react-helmet"
import { Link } from 'react-router-dom';

export default function BookDistribution() {
    return (
        <div>
            <Helmet>
                <title> Book Distribution Program to support school children</title>
            </Helmet>
            <section className="page-header" style={{ backgroundImage: "url(/images/gallerybanner.jpg)" }}>
                <div className="container">
                    <div className="page-header__inner">
                        <h2> Book Distribution Events</h2>
                        <ul className="thm-breadcrumb list-unstyled">
                            <li><Link to="https://kbkwelfareassociation.com/">Home</Link></li>
                            <li><span>/</span></li>
                            <li> Food Distribution </li>
                        </ul>
                    </div>
                </div>
            </section>
            <div className="lightbox-gallery">
                <div className="container">
                    <div className="row photos">
                        <div className="col-lg-12">
                            <div className="block-title text-left">
                                <br />
                                <br />

                                <h2 className="ab-k">Book Distribution Program to support school children</h2>
                                <p className='text-dark'>The KBK Welfare Association, in association with the Lions Club of Hyderabad Digipreneurs AI, successfully organized a Book Distribution Program to support school children and promote the importance of education.
                                    This initiative reflects KBK Welfare’s continued commitment to social responsibility and child education—because every child deserves the opportunity to learn and grow.</p>
                            </div>
                        </div>

                        <div className="col-sm-6 col-md-4 col-lg-3 item">
                            <a href="images/book-distribution/1.webp" data-lightbox="photos"><img className="img-fluid img-glry" src="images/book-distribution/1.webp" alt="Img" /></a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3 item">
                            <a href="images/book-distribution/2.webp" data-lightbox="photos"><img className="img-fluid img-glry" src="images/book-distribution/2.webp" alt="Img" /></a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3 item">
                            <a href="images/book-distribution/3.webp" data-lightbox="photos"><img className="img-fluid img-glry" src="images/book-distribution/3.webp" alt="Img" /></a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3 item">
                            <a href="images/book-distribution/4.webp" data-lightbox="photos"><img className="img-fluid img-glry" src="images/book-distribution/4.webp" alt="Img" /></a>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3 item">
                            <a href="images/book-distribution/5.webp" data-lightbox="photos"><img className="img-fluid img-glry" src="images/book-distribution/5.webp" alt="Img" /></a>
                        </div>
                        


                    </div>
                    <br />
                    <br />
                </div>
            </div>

        </div>
    )
}
